export const COURSE_LIST = 'onelife/courseList';
export const COURSE_DETAILS = 'onelife/courseDetails';
export const LOGIN = 'onelife/login';
export const GET_STUDENT = 'student/getDetails';
export const REGISTERWITHOTP = 'onelife/registerWithOtp';
export const SENDOTP = 'onelife/sendOtp';
export const CHANGE_PASS = 'student/changePassword';
export const GET_BOOKINGS = 'student/getBookings';
export const PAYMENT_REQUEST = 'student/enrollRequest';
export const SAVE_COMMENT = 'student/saveComment';